import { atom } from "recoil";

export const signItem = atom({
  key: "sign/item",
  default: { result: false, info: null, error: null },
});
export const studentSignItem = atom({
  key: "sign/student/item",
  default: { result: false, info: null, error: null },
});
export const parentSignItem = atom({
  key: "sign/parent/item",
  default: { result: false, info: null, error: null },
});
